import { render, staticRenderFns } from "./LayoutNavbarHorizontalItemMultiple.vue?vue&type=template&id=60da0c4c&v-slot%3Aextension=true&"
import script from "./LayoutNavbarHorizontalItemMultiple.vue?vue&type=script&lang=ts&"
export * from "./LayoutNavbarHorizontalItemMultiple.vue?vue&type=script&lang=ts&"
import style0 from "./LayoutNavbarHorizontalItemMultiple.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VList } from 'vuetify/lib/components/VList';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VMenu } from 'vuetify/lib/components/VMenu';
import { VTab } from 'vuetify/lib/components/VTabs';
installComponents(component, {VBtn,VIcon,VList,VListItem,VListItemTitle,VMenu,VTab})
